import React, { useState } from "react";
import { X, Search } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { sortedStates } from "../utils/StaticFormData";
import "../styles/StatePickerModal.css";

interface StatePickerModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const StatePickerModal = ({
  isOpen,
  onClose,
}: StatePickerModalProps) => {
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  if (!isOpen) return null;

  const filteredStates = sortedStates.filter((item) =>
    item.stateName.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const handleSelectState = (alias: string) => {
    navigate(`/chart/${alias}`);
    onClose();
  };

  return (
    <div className="state-modal-overlay" onClick={onClose}>
      <div className="state-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="state-modal-header">
          <h3>Select a Chart</h3>
          <button className="state-modal-close" onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        <div className="state-modal-search">
          <Search size={16} className="search-icon" />
          <input
            type="text"
            placeholder="Search states..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            autoFocus
          />
        </div>

        <div className="state-modal-grid">
          {filteredStates.map((item) => (
            <button
              key={item.stateID}
              className="state-item-btn"
              onClick={() => handleSelectState(item.stateNameAlias)}
            >
              {item.stateName}
            </button>
          ))}
          {filteredStates.length === 0 && (
            <div className="no-results">No states found.</div>
          )}
        </div>
      </div>
    </div>
  );
};
